var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "overlay" }, [
    _c("div", { staticClass: "overlay__wrapper" }, [
      _c("div", { staticClass: "overlay__content" }, [
        _c(
          "ul",
          {
            staticClass:
              "modal__content-list modal__content-list--control modal__content-list--single"
          },
          [
            _c(
              "li",
              { staticClass: "modal__content-item modal__content-item--title" },
              [
                _c("span", { staticClass: "modal__title" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(this.config.lang["modal.control.upload-single"]) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _c("span", {
                  staticClass: "modal__close",
                  on: { click: _vm.closeSingleControl }
                })
              ]
            ),
            _vm._v(" "),
            _c("li", { staticClass: "modal__content-item modal__control" }, [
              _c("div", { staticClass: "modal__control_section_left" }, [
                _c("p", { staticClass: "modal__control_header" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(this.config.lang["modal.control.upload-header"]) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form__formrow form_block" }, [
                  _c("p", { staticClass: "form__row form__wide form_block" }, [
                    _c("button", {
                      ref: "controlform",
                      staticClass: "modal__control_uploadcta",
                      domProps: {
                        innerHTML: _vm._s(
                          this.config.lang["modal.control.dateien-auswaehlen"]
                        )
                      },
                      on: {
                        click: function($event) {
                          return _vm.$refs.controlfile.click()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      ref: "controlfile",
                      staticClass: "display--none",
                      attrs: {
                        type: "file",
                        accept: this.config.settings[
                          "ebrief.upload.accepted_types"
                        ],
                        multiple: ""
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form__row" },
                    [
                      _c("ControlFileList", {
                        attrs: { files: this.files, new: this.numNewFiles },
                        on: { "remove-file": _vm.removeFile }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "modal__control_header" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        this.config.lang["modal.control.attachments-header"]
                      )
                  ),
                  _c("img", {
                    staticClass:
                      "ebrief-tooltip tipso_style upload__section_header_tooltip",
                    staticStyle: {
                      left: "7px",
                      position: "relative",
                      top: "3px",
                      height: "16px"
                    },
                    attrs: {
                      src: "/build/images/info-circle-darkgrey.svg",
                      "data-tipso-key": "upload-attachment-info",
                      "data-tipso-moveleft": "2",
                      "data-tipso-movetop": "1",
                      alt: "Info"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "modal__control_header_sub" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        this.config.lang["modal.control.attachments-header-sub"]
                      ) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form__formrow form__formrow-flat" }, [
                  _c(
                    "div",
                    { staticClass: "form__formrow form__formrow--left" },
                    [
                      _c(
                        "label",
                        {
                          staticClass:
                            "form__pincheckbox form__pincheckbox--pointer",
                          attrs: { for: "single-parameter-attachments" }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.singleFileAttachments,
                                expression: "singleFileAttachments"
                              }
                            ],
                            staticClass: "form__pincheckbox-input",
                            attrs: {
                              type: "checkbox",
                              id: "single-parameter-attachments",
                              name: "single-parameter-attachments",
                              value: "1"
                            },
                            domProps: {
                              checked: Array.isArray(_vm.singleFileAttachments)
                                ? _vm._i(_vm.singleFileAttachments, "1") > -1
                                : _vm.singleFileAttachments
                            },
                            on: {
                              click: _vm.refreshAttributes,
                              change: function($event) {
                                var $$a = _vm.singleFileAttachments,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = "1",
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.singleFileAttachments = $$a.concat([
                                        $$v
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.singleFileAttachments = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.singleFileAttachments = $$c
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "form__pincheckbox-border"
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass:
                              "form__pincheckbox-label form__pincheckbox-label--colorblue",
                            domProps: {
                              innerHTML: _vm._s(
                                this.config.lang[
                                  "modal.control.bulk-file-attachments-text"
                                ]
                              )
                            }
                          })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.singleFileAttachments,
                          expression: "singleFileAttachments"
                        }
                      ],
                      ref: "controlformuploadblock",
                      staticClass: "controlform--upload--attachments"
                    },
                    [
                      _c(
                        "p",
                        { staticClass: "form__row form__wide form_block" },
                        [
                          _c("button", {
                            ref: "controlform",
                            staticClass: "modal__control_uploadcta",
                            domProps: {
                              innerHTML: _vm._s(
                                this.config.lang[
                                  "modal.control.dateien-auswaehlen"
                                ]
                              )
                            },
                            on: {
                              click: function($event) {
                                return _vm.$refs.controattachlfile.click()
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("input", {
                            ref: "controattachlfile",
                            staticClass: "display--none",
                            attrs: {
                              type: "file",
                              accept: this.config.settings[
                                "ebrief.attachments.accepted_types"
                              ],
                              multiple: ""
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form__row form__wide form_block" },
                        [
                          _c("ControlAttachmentList", {
                            attrs: {
                              attachments: this.attachments,
                              new: this.numNewAttachments
                            },
                            on: { "remove-attachment": _vm.removeAttachment }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal__control_section_right" }, [
                _c("p", { staticClass: "modal__control_header" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        this.config.lang["modal.control.printsettings-header"]
                      ) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form__formrow" }, [
                  _c("p", { staticClass: "form__row" }, [
                    _c(
                      "label",
                      {
                        staticClass: "modal__control_label",
                        attrs: { for: "single-parameter-colortype" }
                      },
                      [
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              this.config.lang[
                                "modal.control.printsettings-label-color"
                              ]
                            ) +
                            "\n                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.colorType,
                            expression: "colorType"
                          }
                        ],
                        staticClass: "form__select--modalcontrol",
                        attrs: {
                          id: "single-parameter-colortype",
                          name: "parameter-colortype"
                        },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.colorType = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      _vm._l(
                        this.config.printparameter.single.colorType.select,
                        function(option) {
                          return _c(
                            "option",
                            {
                              attrs: { "data-image": option.image },
                              domProps: { value: option.value }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(option.text) +
                                  "\n                  "
                              )
                            ]
                          )
                        }
                      ),
                      0
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "form__row" }, [
                    _c(
                      "label",
                      {
                        staticClass: "modal__control_label",
                        attrs: { for: "single-parameter-printtype" }
                      },
                      [
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              this.config.lang[
                                "modal.control.printsettings-label-print"
                              ]
                            ) +
                            "\n                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.printType,
                            expression: "printType"
                          }
                        ],
                        staticClass:
                          "js-ms-dropdown form__select--modalcontrol",
                        attrs: {
                          id: "single-parameter-printtype",
                          name: "parameter-printtype"
                        },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.printType = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      _vm._l(
                        this.config.printparameter.single.printType.select,
                        function(option) {
                          return _c(
                            "option",
                            {
                              attrs: { "data-image": option.image },
                              domProps: { value: option.value }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(option.text) +
                                  "\n                  "
                              )
                            ]
                          )
                        }
                      ),
                      0
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "modal__control_header" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        this.config.lang["modal.control.papersettings-header"]
                      ) +
                      "\n            "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form__formrow" }, [
                  _c("p", { staticClass: "form__row" }, [
                    _c(
                      "label",
                      {
                        staticClass: "modal__control_label",
                        attrs: { for: "single-parameter-papertype" }
                      },
                      [
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              this.config.lang[
                                "modal.control.printsettings-label-papertype"
                              ]
                            ) +
                            "\n                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.paperType,
                            expression: "paperType"
                          }
                        ],
                        staticClass:
                          "js-ms-dropdown form__select--modalcontrol",
                        attrs: {
                          id: "single-parameter-papertype",
                          name: "parameter-papertype"
                        },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.paperType = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      _vm._l(
                        this.config.printparameter.single.paperType.select,
                        function(option) {
                          return _c(
                            "option",
                            { domProps: { value: option.value } },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(option.text) +
                                  "\n                  "
                              )
                            ]
                          )
                        }
                      ),
                      0
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form__row" }, [
                    _c("p", { staticClass: "modal__control_label" }, [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            this.config.lang["modal.control.sendc4-header"]
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass:
                          "ebrief-tooltip tipso_style upload__section_header_tooltip",
                        staticStyle: {
                          left: "7px",
                          position: "relative",
                          top: "3px",
                          height: "16px"
                        },
                        attrs: {
                          src: "/build/images/info-circle-darkgrey.svg",
                          "data-tipso-key": "upload-c4",
                          "data-tipso-moveleft": "2",
                          "data-tipso-movetop": "1",
                          alt: "Info"
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass:
                          "form__pincheckbox form__pincheckbox--pointer form__pincheckbox--oneline",
                        attrs: { for: "single-parameter-c4letter" }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.c4letter,
                              expression: "c4letter"
                            }
                          ],
                          staticClass: "form__pincheckbox-input",
                          attrs: {
                            type: "checkbox",
                            id: "single-parameter-c4letter",
                            name: "single-parameter-c4letter",
                            value: "1"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.c4letter)
                              ? _vm._i(_vm.c4letter, "1") > -1
                              : _vm.c4letter
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.c4letter,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "1",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 && (_vm.c4letter = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.c4letter = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.c4letter = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "form__pincheckbox-border" }),
                        _vm._v(" "),
                        _c("span", {
                          staticClass:
                            "form__pincheckbox-label form__pincheckbox-label--colorblue",
                          domProps: {
                            innerHTML: _vm._s(
                              this.config.lang[
                                "modal.control.sendc4-description"
                              ]
                            )
                          }
                        })
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("p", {
                  staticClass: "modal__control_header",
                  domProps: {
                    innerHTML: _vm._s(
                      this.config.lang["modal.control.registeredletter-header"]
                    )
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form__formrow form__formrow--left" },
                  [
                    _c(
                      "label",
                      {
                        staticClass:
                          "form__pincheckbox form__pincheckbox--pointer",
                        attrs: { for: "single-parameter-registeredletter" }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.registeredLetter,
                              expression: "registeredLetter"
                            }
                          ],
                          staticClass: "form__pincheckbox-input",
                          attrs: {
                            type: "checkbox",
                            id: "single-parameter-registeredletter",
                            name: "single-parameter-registeredletter",
                            value: "1"
                          },
                          domProps: {
                            checked: Array.isArray(_vm.registeredLetter)
                              ? _vm._i(_vm.registeredLetter, "1") > -1
                              : _vm.registeredLetter
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.registeredLetter,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = "1",
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.registeredLetter = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.registeredLetter = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.registeredLetter = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "form__pincheckbox-border" }),
                        _vm._v(" "),
                        this.useriscompany
                          ? _c("span", {
                              staticClass:
                                "form__pincheckbox-label form__pincheckbox-label--colorblue",
                              domProps: {
                                innerHTML: _vm._s(
                                  this.config.lang[
                                    "modal.control.registeredletter-label-business"
                                  ]
                                )
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !this.useriscompany
                          ? _c("span", {
                              staticClass:
                                "form__pincheckbox-label form__pincheckbox-label--colorblue",
                              domProps: {
                                innerHTML: _vm._s(
                                  this.config.lang[
                                    "modal.control.registeredletter-label-privat"
                                  ]
                                )
                              }
                            })
                          : _vm._e()
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "modal__control_action" }, [
                  _c("p", { staticClass: "modal__control_actionwrapper" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "form__button form__button--green modal__control_submit",
                        on: { click: _vm.submitSingleControl }
                      },
                      [
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              this.config.lang["modal.control.action-submit"]
                            ) +
                            "\n                "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "modal__control_actionwrapper" }, [
                    _c(
                      "a",
                      {
                        staticClass: "modal__control_cancel",
                        attrs: { href: "javascript:void(0);" },
                        on: { click: _vm.closeSingleControl }
                      },
                      [
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              this.config.lang["modal.control.action-cancel"]
                            ) +
                            "\n                "
                        )
                      ]
                    )
                  ])
                ])
              ])
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }